/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_3_TitleInputs */

const en_pc_rv_3_title = /** @type {(inputs: Pc_Rv_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PSD round-trips`)
};

const zh_pc_rv_3_title = /** @type {(inputs: Pc_Rv_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PSD 往返`)
};

/**
* | output |
* | --- |
* | "PSD round-trips" |
*
* @param {Pc_Rv_3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_3_title = /** @type {((inputs?: Pc_Rv_3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_3_title(inputs)
	return zh_pc_rv_3_title(inputs)
});
export { pc_rv_3_title as "pc.rv.3.title" }